<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="account_wraper">
        <div class="container_large">
          <div class="login_holder">
            <h4>Get Started!</h4>
            <h1>Create your Account</h1>
            <form method="" action="" @submit.prevent="submit()">
              <div class="form_holder legend_form">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form_group">
                      <label>First Name</label>
                      <input
                        type="text"
                        name=""
                        placeholder="First Name"
                        v-model="signUpobj.first_name"
                      />
                      <v-errors :errors="errorFor('first_name')"></v-errors>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form_group">
                      <label>Last Name</label>
                      <input
                        type="text"
                        name=""
                        placeholder="Last Name"
                        v-model="signUpobj.last_name"
                      />
                      <v-errors :errors="errorFor('last_name')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="form_group">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    name=""
                    placeholder="Phone Number"
                    v-model="signUpobj.phone"
                    required
                  />
                  <v-errors :errors="errorFor('phone')"></v-errors>
                </div>
                <div class="form_group">
                  <label>Address</label>
                  <vue-google-autocomplete
                    ref="address"
                    id="map"
                    placeholder="Street address, city, state"
                    v-on:placechanged="getAddressData"
                    v-on:no-results-found="noResultFound"
                    v-on:inputChange="inputChangedAutoComplete"
                    country="us"
                  >
                  </vue-google-autocomplete>
                  <v-errors :errors="errorFor('address')"></v-errors>
                </div>
                <div class="form_group">
                  <label>Apartments</label>
                  <input
                    type="text"
                    name=""
                    placeholder="Apt # (opt)"
                    v-model="signUpobj.apt_num"
                  />
                </div>
                <div class="form_group">
                  <label>Zip Code</label>
                  <input
                    type="text"
                    name=""
                    placeholder="Zip Code"
                    v-model="signUpobj.zip_code"
                    @input="checkPostal('pickup')"
                    :disabled="is_zip_code_disabled"
                  />
                  <v-errors :errors="errorFor('address')"></v-errors>
                  <transition name="fade" v-if="is_postal_found == false">
                    <div
                      class="error_message"
                      v-if="signUpobj.zip_code.length > 4"
                    >
                      <!-- <strong>Sorry!</strong> we do not currently service this -->
                      <!-- area! -->
                    </div>
                  </transition>
                </div>
                <!-- <div class="form_group">
                  <input type="text" name="" placeholder="Full Name" v-model="signUpobj.full_name"
                    autofocus
                    required
                  />
                  <v-errors :errors="errorFor('full_name')"></v-errors>
                </div> -->
                <div class="form_group">
                  <label>Email</label>
                  <input
                    type="text"
                    name=""
                    placeholder="Email"
                    v-model="signUpobj.email"
                    required
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
                <div class="form_group">
                  <label>Password</label>
                  <input
                    type="password"
                    name=""
                    placeholder="Password"
                    v-model="signUpobj.password"
                    @input="matchPassword()"
                    required
                  />
                  <span class="password_hint d-none"
                    >* Password should require regulations characters / symbols
                    ext.</span
                  >
                  <transition-group name="fade" v-if="errors">
                    <p
                      v-for="(error, keyIndex) in errors"
                      :key="keyIndex + 'from'"
                    >
                      <span v-if="error.password" style="color: #b22222">{{
                        error.password
                      }}</span>
                    </p>
                  </transition-group>
                  <v-errors :errors="errorFor('password')"></v-errors>
                </div>
                <!-- <div class="form_group">
                  <input
                    type="password"
                    name=""
                    placeholder="Confirm Password" v-model="signUpobj.confirm_password"   @input="matchPassword()"
                    required
                  />
                  <transition-group name="fade" v-if="errors">
                    <p
                      v-for="(error, keyIndex) in errors"
                      :key="keyIndex + 'from'"
                    >
                      <span v-if="error.password" style="color: #b22222">{{
                        error.password
                      }}</span>
                    </p>
                  </transition-group>
                  <v-errors :errors="errorFor('confirm_password')"></v-errors>
                </div> -->

                <div class="button_holder">
                  <button type="submit" class="button primary_button">
                    Sign Up <i class="fi fi-rr-angle-small-right"></i>
                  </button>
                  <!-- <span
                    ><router-link :to="{ name: 'login' }"
                      >Login</router-link
                    ></span
                  > -->
                </div>
                <div class="agree_text">
                  By clicking on "Sign Up" you agree to the

                  <a href="/terms-and-conditions" target="_blank"
                    >Terms of Use</a
                  >
                  <!-- <router-link :to="{ name: 'terms-and-conditions' }"
                    >Terms of Use</router-link
                  > -->
                  and
                  <a href="/privacy-policy" target="_blank">Privacy Policy</a>
                  <!-- <router-link :to="{ name: 'privacy-policy' }"
                    >Privacy Policy</router-link
                  > -->
                  of dirtydrawz.com
                </div>
              </div>
            </form>
            <div class="social_login">
              <h5>OR</h5>
              <h4>Login using social media</h4>
              <ul>
                <li>
                  <a href="#" @click.prevent="AuthProvider('google')"
                    ><img src="/src/assets/images/google-icon.svg" alt=""
                  /></a>
                </li>
                <li>
                  <a href="#" @click.prevent="AuthProvider('facebook')"
                    ><img src="/src/assets/images/facebook-logo.svg" alt=""
                  /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="men_holding_cloths">
          <img
            src="/src/assets/images/girl-with-laundry.png"
            class="img-fluid"
            alt=""
          />
        </div>
        <!--   Main Content End Here   -->

        <!-- <button >auth Facebook</button> -->
        <!-- <button @click="AuthProvider('google')">auth Google</button> -->
        <!-- <br /><br /> -->
      </section>
    </main>
  </div>
</template>
<script>
import validationErrors from "../../mixins/validationErrors";
import { is422 } from "../../utils/response";
import userApis from "../../Apis/users";
import axios from "axios";
import { logIn, setCurrentUser } from "../../utils/auth";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  mixins: [validationErrors],
  components: {
    VueGoogleAutocomplete,
  },

  data() {
    return {
      status: null,
      url: null,
      errors: null,
      loader: true,

      is_zip_code_disabled: false,
      signUpobj: {
        first_name: null,
        last_name: null,
        full_name: null,
        email: null,
        phone: null,
        password: null,
        confirm_password: null,
        phone: "",
        address: null,
        zip_code: null,
        apt_num: null,
      },
      googleSignInParams: {
        client_id:
          "1011549050527-sn1vk663fudvi1a5ivdt7oimealcdbke.apps.googleusercontent.com",
      },
      is_postal_found: null,

      given_areas: [],
    };
  },

  methods: {
    checkPostal() {
      const index = this.given_areas.findIndex(
        (it) => it == this.signUpobj.zip_code
      );
      if (index === -1) {
        this.is_postal_found = false;
      } else {
        this.is_postal_found = true;
      }
    },
    noResultFound: function (obj) {
      console.log("no result found", obj);
    },
    inputChangedAutoComplete: function (obj) {
      console.log("input change auto", obj.newVal);
      this.signUpobj.address = obj.newVal;
    },
    getAddressData: function (addressData, placeResultData, id) {
      console.log(addressData);
      console.log(placeResultData);
      this.signUpobj.address =
        placeResultData && placeResultData.formatted_address
          ? placeResultData.formatted_address
          : "";

      if (addressData && addressData.postal_code) {
        this.is_show_postal = false;
        const index = this.given_areas.findIndex(
          (it) => it == addressData.postal_code
        );
        if (index === -1) {
          /**postal code not exist in array */
          this.is_postal_found = false;
        } else {
          /**postal code exist in array */
          this.is_postal_found = true;
        }
      } else {
        this.is_show_postal = true;
      }
    },
    // google signup response

    AuthProvider(provider) {
      var self = this;

      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },

    SocialLogin(provider, response) {
      axios
        .post(`${process.env.API_URL}/sociallogin/` + provider, response)
        .then((response) => {
          // console.log(response.data);
          if (response && response.data) {
            logIn();
            setCurrentUser(response.data);
            this.$store.dispatch("islogedIn", response.data);
            this.loader = false;
            this.$router.push({ name: "order" });
          }
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },

    onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const profile = googleUser.getBasicProfile(); // etc etc
      console.log("ID: " + profile.getId()); // Do not send to your backend! Use an ID token instead.
      console.log("Name: " + profile.getName());
      console.log("Image URL: " + profile.getImageUrl());
      console.log("Email: " + profile.getEmail());
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
    },

    // matching passwords
    matchPassword() {
      if (
        this.signUpobj.password &&
        this.signUpobj.confirm_password &&
        this.signUpobj.password != this.signUpobj.confirm_password
      ) {
        this.errors = [{ password: "Password does not match" }];
        return;
      } else {
        return (this.errors = null);
      }
    },
    async submit() {
      // if (!this.is_postal_found) {
      //   this.errors = [{ errors: "We don't currently service this area." }];
      //   return false;
      // }

      this.loader = true;

      // await this.$axios.get("/index.php/sanctum/csrf-cookie");
      await userApis.getCSRF();
      await userApis
        .requestUsers("post", this.signUpobj)
        .then((response) => {
          if (response.status == 200) {
            const messageNotify =
              "An email has been sent to " +
              this.signUpobj.email +
              ", please verify your account.";
            this.$router.push({
              name: "login",
              params: { messageNotify: messageNotify },
            });
          }
        })
        .catch((error) => {
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
        })
        .then(() => {
          this.loader = false;
        });
    },

    dumpGivenAreas() {
      this.given_areas.push("02127");
      this.given_areas.push("02118");
      this.given_areas.push("02123");
      this.given_areas.push("02116");
      this.given_areas.push("02108");
      this.given_areas.push("02215");
      this.given_areas.push("02120");
      this.given_areas.push("02474");
      this.given_areas.push("02476");
      this.given_areas.push("02134");
      this.given_areas.push("02478");
      this.given_areas.push("02135");
      this.given_areas.push("02445");
      this.given_areas.push("02446");
      this.given_areas.push("02138");
      this.given_areas.push("02138");
      this.given_areas.push("02139");
      this.given_areas.push("02140");
      this.given_areas.push("02141");
      this.given_areas.push("02142");
      this.given_areas.push("02163");
      this.given_areas.push("02238");
      this.given_areas.push("02150");
      this.given_areas.push("02108");
      this.given_areas.push("02109");
      this.given_areas.push("02110");
      this.given_areas.push("02111");
      this.given_areas.push("02112");
      this.given_areas.push("02117");
      this.given_areas.push("02118");
      this.given_areas.push("02127");
      this.given_areas.push("02113");
      this.given_areas.push("02114");
      this.given_areas.push("02115");
      this.given_areas.push("02116");
      this.given_areas.push("02123");
      this.given_areas.push("02128");
      this.given_areas.push("02133");
      this.given_areas.push("02163");
      this.given_areas.push("02196");
      this.given_areas.push("02199");
      this.given_areas.push("02205");
      this.given_areas.push("02206");
      this.given_areas.push("02212");
      this.given_areas.push("02215");
      this.given_areas.push("02266");
      this.given_areas.push("02283");
      this.given_areas.push("02201");
      this.given_areas.push("02203");
      this.given_areas.push("02204");
      this.given_areas.push("02210");
      this.given_areas.push("02211");
      this.given_areas.push("02217");
      this.given_areas.push("02222");
      this.given_areas.push("02241");
      this.given_areas.push("02284");
      this.given_areas.push("02293");
      this.given_areas.push("02295");
      this.given_areas.push("02297");
      this.given_areas.push("02298");
      this.given_areas.push("02129");
      this.given_areas.push("02467");
      this.given_areas.push("02121");
      this.given_areas.push("02122");
      this.given_areas.push("02124");
      this.given_areas.push("02125");
      this.given_areas.push("02149");
      this.given_areas.push("02130");
      this.given_areas.push("02148");
      this.given_areas.push("02153");
      this.given_areas.push("02155");
      this.given_areas.push("02176");
      this.given_areas.push("02492");
      this.given_areas.push("02461");
      this.given_areas.push("02464");
      this.given_areas.push("02459");
      this.given_areas.push("02465");
      this.given_areas.push("02458");
      this.given_areas.push("02462");
      this.given_areas.push("02151");
      this.given_areas.push("02118");
      this.given_areas.push("02119");
      this.given_areas.push("02120");
      this.given_areas.push("02170");
      this.given_areas.push("02169");
      this.given_areas.push("02171");
      this.given_areas.push("02269");
      this.given_areas.push("02144");
      this.given_areas.push("02145");
      this.given_areas.push("02451");
      this.given_areas.push("02452");
      this.given_areas.push("02453");
      this.given_areas.push("02454");
      this.given_areas.push("02472");
      this.given_areas.push("02471");
      this.given_areas.push("02477");
      this.given_areas.push("02482");
      this.given_areas.push("02132");
      this.given_areas.push("01890");
      this.loader = false;
    },
  },
  async created() {
    this.dumpGivenAreas();
    if (this.$route.params && this.$route.params.zip_code) {
      this.is_zip_code_disabled = true;
      this.signUpobj.zip_code = this.$route.params.zip_code;
    }
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
  computed: {
    hasErrors() {
      return 422 === this.status && this.errors !== null;
    },
  },
};
</script>
<style scoped>
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
  cursor: pointer;
}
</style> 


// WEBPACK FOOTER //
// src/components/Auth/signup.vue